// extracted by mini-css-extract-plugin
module.exports = {"shippingModalUrgencyTimer":"UrgencyTimer_shippingModalUrgencyTimer__I52Y5","urgencyTimer":"UrgencyTimer_urgencyTimer__pBcbZ"};